import React from 'react';
import { useAppSelector, useAppDispatch } from '../app/hooks';

import Box from '@mui/material/Box';
import Select from "react-select";

const ChangePitcher = () => {

    return (
        <>
            <Box>
                <Select placeholder="更換當前投手" />
            </Box>
        </>
    );
}

export default ChangePitcher;
